import { useContext, useEffect } from 'react';
import { copy, removeFields } from '@thd-olt-functional/utils';
import {
  useDataModel
} from '@thd-nucleus/data-sources';
import {
  params,
  string as stringType,
  arrayOf as arrayType,
  customType
} from '@thd-nucleus/data-sources/react/dataModel/prop-types';
import { CustomerContext } from '../components/CustomerContext';

/*
apollo has some race condition and because this hook is called recursively with ds
useDataModel -> useStore -> useMembershipInformation -> useDataModel
there is functionality in the cache for it to return in loading state for loyaltyMembership
even when its succesfully returned and in cache. As a workaround changing fetchPolicy
to cache-only forces it to pull from cache early.
*/

let hasData = false;
export const useMembershipInformation = ({ customerType }) => {

  const isClient = typeof window !== 'undefined';

  const { membershipInformation: savedMembershipInformation } = useContext(CustomerContext);

  const shouldSkip = savedMembershipInformation || customerType !== 'B2B' || !isClient;

  const options = {
    ssr: false,
    dataModel: useMembershipInformation.dataModel,
    fetchPolicy: hasData ? 'cache-only' : 'cache-first',
    mounted: true,
    skip: shouldSkip
  };

  const { data, loading, error } = useDataModel('loyaltyMembership', options);

  let loyaltyData = null;
  if (data) {
    hasData = true;
    const dataClone = copy(data);
    loyaltyData = removeFields(dataClone.data, ['__typename']) || { loyaltyMembership: null };
  }

  useEffect(() => {
    if (loyaltyData && !loading) {
      // eslint-disable-next-line no-unused-expressions
      window.THDCustomer?.default?.setMembershipInformation(loyaltyData.loyaltyMembership);
    }
  }, [loading]);

  // Return for non-B2B Customer
  if (!isClient || customerType !== 'B2B') {
    return {
      apiResponse: {
        data: null,
        error: null,
        loading: null,
      },
      customerType,
    };
  }

  // Return if loyaltyMembership Information is provided by context
  if (savedMembershipInformation) {
    return {
      apiResponse: {
        data: { loyaltyMembership: savedMembershipInformation },
        error: null,
        loading: false,
      },
      customerType,
    };
  }

  // Return if loyaltyMembership Information is provided by query
  return {
    apiResponse: {
      data: loyaltyData,
      error,
      loading,
    },
    customerType,
  };
};

useMembershipInformation.dataModel = {
  loyaltyMembership: params().shape({
    svocID: stringType(),
    programTiers: arrayType(
      customType('ProgramTiers').shape({
        tier: stringType(),
        program: stringType(),
      })
    ),
  }),
};
